import ConnectedContainer from "components/container/ConnectedContainer.tsx";
import { useAppDispatch, useAppSelector } from "config/store";
import { useMount } from "react-use";
import { authActions } from "config/store/modules/auth.ts";
import Button from "components/atom/button/Button.tsx";
import locationPng from "assets/images/location.png";
import { useCallback, useState } from "react";
import { EventType } from "globals/types/models.ts";
import EventCard from "components/layouts/card/EventCard.tsx";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


function ViewerProfilePage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const myEvents: EventType[] = useAppSelector(state => state.auth.myEvents);


  const [isLoading, setIsLoading] = useState<boolean>(true);

  useMount(async () => {
    await dispatch(authActions.getMyFavoriteEvents());
    setIsLoading(false);
  });

  const onEventClick = useCallback((event: EventType) => {
    navigate(`/events/${event.handle}`);
  }, [navigate]);

  return (
    <ConnectedContainer title={t("user.myProfile")}>

      {!isLoading && (
        <div className="pb-24 sm:pb-0">

          {myEvents.length === 0 && (
            <div
              className="mx-auto flex w-full flex-1 flex-col items-center justify-center gap-6 md:max-w-[600px]">
              <img src={locationPng} className="mx-auto block h-[200px] w-auto" />
              <h2 className="text-center text-xl text-gray-900">
                {t("user.noFavoriteEventsTitle")}
              </h2>
              <div className="hidden sm:block">
                <Button className="w-full" to="/map">
                  {t("event.goToMap")}
                </Button>
              </div>
            </div>
          )}

          {myEvents.length > 0 && (
            <div className="w-full">
              <div className="flex flex-row items-center justify-between">
                <h3 className="text-base sm:text-xl font-medium text-gray-900">
                  {t("event.favoriteEvents")}
                </h3>
              </div>
              <div
                className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {myEvents.map(event => (
                  <EventCard key={event.id} event={event} onClick={onEventClick} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </ConnectedContainer>
  );
}

export default ViewerProfilePage;
